import { useEffect, useRef } from 'react';

export const useAnimationsTracker = () => {
  const { current: closeAnimations } = useRef({ overlay: false, modal: false });
  const isOnCloseCalled = useRef(false);

  useEffect(() => {
    // NOTE If the onClose callback is called and the modal is not closed yet
    //      (animations), we log an error to prevent the developer to use the
    //      `onCloseComplete` callback to handle the modal closing correctly.
    return () => {
      if (
        isOnCloseCalled.current &&
        !Object.values(closeAnimations).every(Boolean)
      ) {
        // eslint-disable-next-line no-console
        console.error(
          '[Modal]: The component is not mounted, make sure you used `onCloseComplete` to handle the modal closing.',
        );
      }
    };
  }, [closeAnimations]);

  return {
    areAnimationsComplete() {
      return Object.values(closeAnimations).every(Boolean);
    },
    markAnimationComplete(component: 'modal' | 'overlay') {
      closeAnimations[component] = true;
    },
    markOnCloseCalled() {
      isOnCloseCalled.current = true;
    },
  };
};
